<template>
  <v-dialog v-model="visible" max-width="1360px" scrollable>
    <v-card>
      <v-toolbar dense flat color="primary" dark>
        <v-toolbar-title class="text-subtitle-1 font-weight-bold">
          <v-icon left small>mdi-cash-multiple</v-icon>
          Listas de Precio
        </v-toolbar-title>
        <v-spacer />
        <v-btn icon small dark @click="cerrar">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>

      <v-card-text class="pa-4">
        <!-- Info universidad -->
        <v-sheet v-if="universidad" rounded outlined class="pa-3 mb-4">
          <div class="d-flex align-center">
            <v-icon color="primary" class="mr-2">mdi-school</v-icon>
            <div>
              <div class="text-caption grey--text">Universidad</div>
              <div class="text-subtitle-2 font-weight-medium">{{ universidad.nombre }}</div>
            </div>
          </div>
        </v-sheet>

        <!-- Botones -->
        <div class="d-flex align-center mb-3">
          <v-btn small color="primary" @click="$refs.formularioRef.abrir()">
            <v-icon left small>mdi-plus</v-icon>
            Registrar
          </v-btn>

          <v-spacer />

          <v-btn small outlined color="primary" @click="listar" :loading="cargando">
            <v-icon left small>mdi-refresh</v-icon>
            Recargar
          </v-btn>
        </div>

        <v-tabs v-model="tabActiva" class="mb-3">
          <v-tab>
            <v-icon left small>mdi-view-list</v-icon>
            Detalle por Área
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-table</v-icon>
            Tabla General
          </v-tab>
          <v-tab>
            <v-icon left small>mdi-pivot-table</v-icon>
            Tabla Pivot
          </v-tab>
        </v-tabs>

        <v-tabs-items v-model="tabActiva">
          <v-tab-item :transition="false" :reverse-transition="false">
            <ListadoListaPrecio
              :items="items"
              :cargando="cargando"
              @agregar-area="abrirFormularioArea"
              @duplicar-area="duplicarArea"
              @editar-area="editarArea"
              @cambio-estado="listar" />
          </v-tab-item>

          <v-tab-item :transition="false" :reverse-transition="false">
            <TablaListaPrecio :items="items" :cargando="cargando" />
          </v-tab-item>

          <v-tab-item :transition="false" :reverse-transition="false">
            <TablaPivotListaPrecio :items="items" :cargando="cargando" />
          </v-tab-item>
        </v-tabs-items>
      </v-card-text>

      <v-divider />

      <v-card-actions class="px-4 py-3">
        <v-spacer />
        <v-btn text color="grey darken-1" @click="cerrar">Cerrar</v-btn>
      </v-card-actions>
    </v-card>

    <FormularioListaPrecio
      ref="formularioRef"
      :universidadId="universidad ? universidad.id : null"
      @guardado="listar" />

    <FormularioAreaListaPrecio
      ref="formularioAreaRef"
      :universidadId="universidad ? universidad.id : null"
      @guardado="listar" />
  </v-dialog>
</template>

<script>
import ListadoListaPrecio from './ListadoListaPrecio.vue';
import TablaListaPrecio from './TablaListaPrecio.vue';
import TablaPivotListaPrecio from './TablaPivotListaPrecio.vue';
import FormularioListaPrecio from './FormularioListaPrecio.vue';
import FormularioAreaListaPrecio from './FormularioAreaListaPrecio.vue';
import ListaPrecioService from '../../services/lista-precio.service';

export default {
  name: 'ModalListaPrecio',
  components: {
    ListadoListaPrecio,
    TablaListaPrecio,
    TablaPivotListaPrecio,
    FormularioListaPrecio,
    FormularioAreaListaPrecio,
  },
  props: {
    universidad: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      visible: false,
      items: [],
      cargando: false,
      tabActiva: 0,
    };
  },
  methods: {
    abrir() {
      this.visible = true;
      this.listar();
    },
    cerrar() {
      this.visible = false;
      this.items = [];
    },
    abrirFormularioArea(item) {
      this.$refs.formularioAreaRef.abrir(item);
    },
    duplicarArea({ item, area }) {
      this.$refs.formularioAreaRef.abrir(item, area, { modo: 'duplicar' });
    },
    editarArea({ item, area }) {
      this.$refs.formularioAreaRef.abrir(item, area, { modo: 'editar' });
    },
    async listar() {
      this.cargando = true;

      try {
        const params = {};

        if (this.universidad?.id) {
          params.universidadId = this.universidad.id;
        }

        const { data } = await ListaPrecioService.findResumen({ params });

        this.items = data.datos || [];
      } catch (error) {
        const mensaje = error?.response?.data?.mensaje || error.message;

        this.items = [];
        this.$notify({
          group: 'notifications',
          title: 'Error',
          text: mensaje || 'Error al obtener resumen de listas de precio',
          type: 'error',
        });
      } finally {
        this.cargando = false;
      }
    },
  },
};
</script>
